if (!customElements.get('back-to-top')) {
	customElements.define('back-to-top', class ButtonScrollTop extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('.back-to-top');

			if (!this.button) {
				return;
			}

			this.timeout = null;
			window.addEventListener('scroll', () => {
				clearTimeout(this.timeout);

				this.timeout = setTimeout(() => {
					if (window.scrollY > 450) {
						this.button.classList.add('back-to-top-visible');
					} else {
						this.button.classList.remove('back-to-top-visible');
					}
				}, 200)
			});

			this.button.addEventListener('click', (event) => {
				event.preventDefault();
				this.handleClick();
			});
		}

		handleClick() {
			document.documentElement.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	});
}

/* NYF: compact Shop by Designer footer dropdown */
(() => {
  const enhanceDesignerFooter = () => {
    const footer = document.querySelector('.footer');
    if (!footer || footer.dataset.designerDropdownReady === 'true') return;

    const menuBlocks = footer.querySelectorAll('.footer-block--menu');
    let designerBlock = null;

    menuBlocks.forEach((block) => {
      const heading = block.querySelector('.footer-block__heading');
      if (heading && heading.textContent.trim().toUpperCase() === 'SHOP BY DESIGNER') {
        designerBlock = block;
      }
    });

    if (!designerBlock) return;

    const heading = designerBlock.querySelector('.footer-block__heading');
    const list = designerBlock.querySelector('.footer-block__details-content');
    if (!heading || !list || designerBlock.classList.contains('footer-designer-menu')) return;

    designerBlock.classList.add('footer-designer-menu');
    const listId = `FooterDesignerList-${Math.random().toString(36).slice(2, 9)}`;
    list.id = listId;
    list.classList.add('footer-designer-list');
    list.hidden = true;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'footer-designer-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', listId);

    const label = document.createElement('span');
    label.textContent = 'Browse all designers';
    const icon = document.createElement('span');
    icon.className = 'footer-designer-toggle__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';

    toggle.append(label, icon);
    heading.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      list.hidden = isOpen;
      icon.textContent = isOpen ? '+' : '−';
    });

    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        list.hidden = true;
        icon.textContent = '+';
        toggle.focus();
      }
    });

    if (!document.getElementById('nyf-footer-designer-dropdown-style')) {
      const style = document.createElement('style');
      style.id = 'nyf-footer-designer-dropdown-style';
      style.textContent = `
        .footer-designer-menu .footer-block__heading { margin-bottom: .35rem; }
        .footer-designer-toggle {
          width: 100%;
          max-width: 24rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          padding: .8rem 0;
          margin: 0;
          border: 0;
          border-bottom: .1rem solid rgba(var(--color-foreground), .18);
          background: transparent;
          color: rgb(var(--color-foreground));
          font: inherit;
          font-size: calc(var(--font-body-scale) * 1.45rem);
          text-align: left;
          cursor: pointer;
        }
        .footer-designer-toggle:hover span:first-child { text-decoration: underline; text-underline-offset: .3rem; }
        .footer-designer-toggle:focus-visible { outline: .2rem solid currentColor; outline-offset: .3rem; }
        .footer-designer-toggle__icon { font-size: 2rem; line-height: 1; font-weight: 300; }
        .footer-designer-list {
          max-height: 28rem;
          max-width: 24rem;
          overflow-y: auto;
          overscroll-behavior: contain;
          margin: .8rem 0 0;
          padding: .2rem .7rem .4rem 0;
          scrollbar-width: thin;
        }
        .footer-designer-list[hidden] { display: none !important; }
        .footer-designer-list > li { margin-right: 0 !important; }
        .footer-designer-list .list-menu__item--link { display: block; padding: .35rem 0; }
        @media screen and (max-width: 749px) {
          .footer-designer-toggle,
          .footer-designer-list { max-width: 100%; }
          .footer-designer-list { max-height: 24rem; }
        }
      `;
      document.head.appendChild(style);
    }

    footer.dataset.designerDropdownReady = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDesignerFooter, { once: true });
  } else {
    enhanceDesignerFooter();
  }
})();